/*
 * -----------------------------------------------------------------------
 *  <copyright file="signalr-service.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import {
    HttpTransportType,
    HubConnectionBuilder,
    HubConnectionState,
    JsonHubProtocol,
    LogLevel,
} from '@microsoft/signalr';

import doLogout from './auth.service';
import Constants from './constants';
import Settings from 'settings/settings';
import { Logger } from 'utils/logger';

let _user: any = null;

const connection = new HubConnectionBuilder()
    .withUrl(`${Settings.api.webSocketUrl()}/messaging`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .withHubProtocol(new JsonHubProtocol())
    .configureLogging(LogLevel.None)
    .build();

// re-establish the connection if connection dropped
connection.onclose((error) => {
    console.assert(connection.state === HubConnectionState.Disconnected);
    // console.log('Connection closed due to error. Try refreshing this page to restart the connection', error);
});

connection.onreconnecting((error) => {
    console.assert(connection.state === HubConnectionState.Reconnecting);
    // Logger.log('Connection lost due to error. Reconnecting.', error);
});

connection.onreconnected((connectionId) => {
    console.assert(connection.state === HubConnectionState.Connected);
    // Logger.log('Connection reestablished. Connected with connectionId', connectionId);
});

connection.on('ForceLogout', (reason: string, users: [string]) => {
    // Only log them out if users is null or their user id is included in the list of users and they're not a system admin
    if (_user && users && users.indexOf(_user.id) < 0) return;

    if (reason.toLowerCase().match('email verification required')) doLogout(null, { user: _user }, 'EmailVerification');
    else doLogout(null, { user: _user }, 'ForceLogout');

    // Logger.log('Logout forced', users, reason);
});

const connectToServer = (user: any) => {
    _user = user;
    const groupName: string = user.systemAdminLevel > 0 ? Constants.ObjectId.Empty : user.organisationKey;

    if (connection.state !== HubConnectionState.Connected) {
        connection
            .start()
            .then(() => {
                connection.invoke('JoinOrganisation', groupName);
            })
            .then(() => {
                // Logger.log('Joined organisation for real-time messaging: ', groupName);
            })
            .catch((ex: any) => {
                console.log('Error connecting', ex);
            });
    } else {
        connection
            .invoke('JoinOrganisation', groupName)
            .then(() => {
                // Logger.log('Joined organisation for real-time messaging: ', groupName);
            })
            .catch((ex: any) => {
                console.log('Error connecting', ex);
            });
    }
};

export { connectToServer, connection };
